module.exports = __webpack_public_path__ + "img/img25.ee238d19.svg";